export default safe => {
  console.log(safe); //vue的this对象
  return {
    lazy: true,
    tip: false,
    simplePage: true,
    searchShow: false,
    // searchMenuSpan: 6,
    tree: true,
    border: true,
    /** 表格索引 */
    index: true,
    /** 索引说明 */
    indexLabel: "No",
    /** 表格搜索显隐按钮 */
    searchShowBtn: false,
    /** 是否启用功能按钮 */
    searchIcon: false,
    searchIndex: 0,
    /** 表格查看按钮 */
    viewBtn: false,
    /** 表格新增按钮 */
    addBtn: false,
    /** 表格删除按钮 */
    delBtn: false,
    /** 表格修改按钮 */
    editBtn: false,
    /** 表格搜索按钮 */
    searchBtn: false,
    /** 表格清空按钮 */
    emptyBtn: false,
    /** 表格列操作按钮 */
    columnBtn: false,
    /** 表格刷新数据按钮 */
    refreshBtn: false,
    /** 开启拖拽功能 */
    sortable: true,
    // dragHandler: true,
    rowSort: true,
    columnSort: true,
    menuWidth: 120,
    // menuFixed: true,
    column: [{
        label: "乐播媒资ID",
        prop: "renderMediaId"
      },
      {
        label: "媒资名称",
        prop: "name",
        slot: true,
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: true
      },
      // {
      //   label: "分集类型",
      //   prop: "mediaType"
      // },
      {
        label: "媒资类型",
        prop: "type",
        // <!-- 0其它 1电影 2电视剧 3动画片 4短剧 -->
        dicData: [{
            label: "其它",
            value: 0
          },
          {
            label: "电影",
            value: 1
          },
          {
            label: "电视剧",
            value: 2
          },
          {
            label: "动画片",
            value: 3
          },
          {
            label: "短剧",
            value: 4
          },
          {
            label: "电影票",
            value: 5
          },
          {
            label: "团购券",
            value: 6
          }
        ]
      },
      {
        label: "横图",
        prop: "horizontalImg",
        slot: true
      },
      {
        label: "来源",
        prop: "partnerName",
      },
      {
        label: "展示选择",
        prop: "showOption",
        width: 200,
        slot: true
      },
      {
        label: "媒资状态",
        prop: "status",
        width: 100,
        slot: true
        // dicData: [{
        //     label: "上线",
        //     value: 1
        //   },
        //   {
        //     label: "下线",
        //     value: 0
        //   }
        // ]
      },
      {
        label: "排序",
        prop: "sortOption",
        width: 120,
        slot: true
      },
      {
        label: "",
        prop: "my",
        hide: true,
        showColumn: false,
        search: true,
        display: false,
        menuClassName: "myClass",
        searchslot: true
      }
    ]
  };
  // return {
  //   title: '表格的标题',
  //   sortable: true,
  //   dragHandler: true,
  //   border: true,
  //   align: 'center',
  //   menuAlign: 'center',
  //   column: [
  //     {
  //       label: '姓名',
  //       prop: 'name'
  //     },
  //     {
  //       label: '性别',
  //       prop: 'sex'
  //     },
  //     {
  //       label: '日期',
  //       prop: 'date',
  //       type: 'date',
  //       format: 'yyyy-MM-dd hh:mm:ss',
  //       valueFormat: 'yyyy-MM-dd hh:mm:ss'
  //     }
  //   ]
  // };
};
